import {
  forwardRef,
  ForwardRefRenderFunction,
  ReactNode,
  TextareaHTMLAttributes,
} from 'react'
import styled from 'styled-components'

interface IFProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string
  label?: Exclude<ReactNode, boolean | null | undefined>
  error?: Exclude<ReactNode, boolean | null | undefined>
}

const Textarea: ForwardRefRenderFunction<HTMLTextAreaElement, IFProps> = (
  { label, className, children, error = '', ...props },
  ref,
) => {
  return (
    <StyledWrapper className={className}>
      {label && <div className="label">{label}</div>}
      <textarea
        ref={ref}
        rows={5}
        autoComplete="off"
        data-error={!!error}
        {...props}
      />
      {children}
      {error && <div className="error">{error}</div>}
    </StyledWrapper>
  )
}

export default forwardRef(Textarea)

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;
  .label {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  textarea {
    font-family: inherit;
    letter-spacing: inherit;
    width: 100%;
    height: 37px;
    outline: none;
    border: none;
    flex-shrink: 1;
    background-color: white;
    border: 1px solid #e8e8e8;
    padding: 8px;
    border-radius: 5px;
    resize: none;
    &[data-error='true'] {
      border: 1px solid #ef2929;
    }
  }
  textarea[disabled] {
    color: #999;
    background-color: #eee;
  }
  .error {
    font-size: 12px;
    margin-top: 10px;
    color: #ef2929;
    width: 250px;
  }
`
